
import { z } from 'zod';
import { TechniquePosition, TechniqueType, TechniqueDifficulty } from '@/types/technique';

// Form schema for validation
export const createTechniqueSchema = z.object({
  name: z.string().min(3, { message: 'Name must be at least 3 characters long' }),
  description: z.string().min(10, { message: 'Description must be at least 10 characters long' }),
  technique_position: z.enum(['standing', 'top', 'bottom', 'transitional'] as const),
  technique_type: z.enum(['choke', 'joint_lock', 'sweep', 'takedown', 'control', 'escape', 'defensive', 'guard_passing', 'other'] as const),
  difficulty: z.enum(['beginner', 'intermediate', 'advanced'] as const),
  image_url: z.string().optional(),
  video_url: z.string().optional(),
  posture: z.enum(['offensive', 'defensive']).optional(),
  key_points: z.string(),
  common_mistakes: z.string(),
  personal_notes: z.string().optional(),
  is_private: z.boolean().default(true),
});

export type CreateTechniqueFormValues = z.infer<typeof createTechniqueSchema>;

// Default values for the form
export const defaultFormValues: CreateTechniqueFormValues = {
  name: '',
  description: '',
  technique_position: 'standing' as TechniquePosition,
  technique_type: 'choke' as TechniqueType,
  difficulty: 'beginner' as TechniqueDifficulty,
  image_url: '',
  video_url: '',
  posture: undefined,
  key_points: '',
  common_mistakes: '',
  personal_notes: '',
  is_private: true,
};
